import { TemperatureScales, TemperatureConverter } from "./temperature-value";
import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";

@autoinject
export class TemperatureFormatValueConverter {
	constructor(private i18n: I18N) { }
	toView(value: number) {

		if (value === null || value === undefined || isNaN(value)) {
			return this.i18n.tr("offline");
		}
		let temperatureScale = localStorage.getItem("temperature-scale");
		if (!temperatureScale) {
			temperatureScale = TemperatureScales.fahrenheit;
		}

		switch (temperatureScale) {
			case TemperatureScales.celsius:
				return `${value.toFixed(1)} °C`;
			default:
				const temperature = TemperatureConverter.toFahrenheit(value);
				return `${temperature.toFixed(1)} °F`;
		}

	}
}

